document.addEventListener('DOMContentLoaded', function () {
    const submenuTriggers = document.querySelectorAll('.submenu-trigger');
    const backButtons = document.querySelectorAll('.ml-mobile-menu_back-button');

    submenuTriggers.forEach(trigger => {
        trigger.addEventListener('click', function () {
            const subItemsList = this.closest('.menu-item').querySelector('.sub-menu');
            // Toggle the expanded class for transition
            subItemsList.classList.toggle('expanded');
        });
    });

    backButtons.forEach(backButton => {
        backButton.addEventListener('click', function () {
            const subMenu = this.closest('.sub-menu');
            console.log(subMenu)
            // Toggle the expanded class for transition
            subMenu.classList.toggle('expanded');
        });
    });
});